var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tab-item',[_c('v-card',{attrs:{"flat":""}},[_c('h3',{staticClass:"text-h6 font-weight-bold"},[_vm._v("検査情報")]),_vm._v(" "),_c('v-card-text',{staticClass:"pa-0"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }